import React from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';

import TransactionPDF from './TransactionPDF';
import ShowMore from '../ShowMore';

const TransactionsTableRowShowMore = ({ transaction }) => {
  const options = [
    {
      link: transaction.showDetailsUrl,
      label: <I18nText id="billing.transactions.list.label.view_detail" />,
    },
  ];

  if (transaction.id) {
    options.push({
      key: 'transaction-pdf',
      item: <TransactionPDF transactionId={transaction.id} />,
    });
  }

  return <ShowMore options={options} />;
};

TransactionsTableRowShowMore.propTypes = {
  transaction: PropTypes.shape({
    showDetailsUrl: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default TransactionsTableRowShowMore;
